module.exports = __webpack_public_path__ + "img/四川天府新区正兴小学.4ac9ec9f.jpg";